import React from 'react';
import Navigation from '@/components/navigation/Navigation';
import Footer from '@/components/landing/Footer';
import { Box } from '@mui/material';

interface PublicLayoutProps {
  children: React.ReactNode;
  hasDarkHero?: boolean;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ 
  children,
  hasDarkHero = false
}) => {
  return (
    <Box 
      sx={{ 
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        width: '100vw',
        maxWidth: '100%',
        position: 'relative',
        bgcolor: 'background.default',
      }}
    >
      {/* Navigation */}
      <Box
        sx={{
          position: hasDarkHero ? 'absolute' : 'relative',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1100,
          height: { xs: '64px', sm: '72px' },
        }}
      >
        <Navigation hasDarkHero={hasDarkHero} />
      </Box>

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          position: 'relative',
          background: hasDarkHero 
            ? 'linear-gradient(180deg, #F7FAFC 0%, #EDF2F7 100%)'
            : 'linear-gradient(180deg, #F7FAFC 0%, #EDF2F7 100%)',
        }}
      >
        {children}
      </Box>

      {/* Footer */}
      <Footer />
    </Box>
  );
};

export default PublicLayout; 